import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const domainTarget = { kind: "configuration" as const, field: "domain" };

export const mattermost = defineConnector({
  identifier: "mattermost",
  name: "Mattermost",
  tagLine: "Open source team messaging",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/api/.*`
      : "https://.*\\.mattermost\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Mattermost instance URL",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-team.mattermost.com",
          target: domainTarget,
        },
      ],
    },
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Mattermost, go to **Profile › Security › Personal Access Tokens** and create a new token.",
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v4/users/me`,
  },
});
